window.actualizarTablaEntregaLinea = null;
window.actualizarTablaAlmacenado   = null;
window.actualizarTablaConsumido    = null;
window.actualizarBalanceSoplado    = null;

if (window.location.pathname === '/soplado/periodo' || window.location.pathname === '/zona-trabajo') {

    const CAPACIDAD_PAQUETE_DEFAULT = 140;
    window.unidadEmpaqueSoplado = CAPACIDAD_PAQUETE_DEFAULT;

    const fmt = n => (n === null || n === '' || isNaN(n))
        ? '0'
        : new Intl.NumberFormat('en-US').format(Number(n));

    const obtenerUnidadEmpaqueSoplado = () => {
        const canvaEntrega = document.getElementById('canvaEntregaSoplado');
        const valorData = canvaEntrega ? canvaEntrega.getAttribute('data-unidad-empaque') : '';
        const unidadEmpaque = parseInt(valorData || window.unidadEmpaqueSoplado, 10) || CAPACIDAD_PAQUETE_DEFAULT;
        return unidadEmpaque;
    };

    const filaSinDatos = (cols, texto) => `
        <tr class="no-data">
            <td colspan="${cols}">
                <div class="cont-no-data">
                    <img class="icono-pequeño-gris" src="/public/build/img/icons/informacion.svg" alt="">
                    ${texto}
                </div>
            </td>
        </tr>`;

    // ── Balance: (Producción neta + saldo inicio turno + paq. consumidos - saldo fin turno)
    // debe coincidir con (paq. almacenados + entregados en línea).
    // Las entregas en línea ya se registran en unidades directas, por lo que no se multiplican
    // por unidadEmpaque como sí ocurre con almacenados/consumidos.
    const renderBalance = (paqCreados, paqAlmacenados, undsEntregados, paqConsumidos, undsNetas, saldoInicioTurno, saldoFinTurno, unidadEmpaque) => {
        const elCreados        = document.getElementById('balancePaquetesCreados');
        const elAlmacenados    = document.getElementById('balancePaquetesAlmacenados');
        const elEntregados     = document.getElementById('balanceUnidadesEntregados');
        const elConsumidos     = document.getElementById('balancePaquetesConsumidos');
        const elCreadosUnd     = document.getElementById('balanceCreadosUnd');
        const elAlmacenadosUnd = document.getElementById('balanceAlmacenadosUnd');
        const elConsumidosUnd  = document.getElementById('balanceConsumidosUnd');
        const elEstado         = document.getElementById('balanceEstado');
        const elIcono          = document.getElementById('balanceEstadoIcono');
        const elTexto          = document.getElementById('balanceEstadoTexto');

        if (elCreados)        elCreados.textContent        = fmt(paqCreados);
        if (elCreadosUnd)     elCreadosUnd.textContent     = fmt(paqCreados * unidadEmpaque) + ' und';
        if (elAlmacenados)    elAlmacenados.textContent    = fmt(paqAlmacenados);
        if (elAlmacenadosUnd) elAlmacenadosUnd.textContent = fmt(paqAlmacenados * unidadEmpaque) + ' und';
        if (elEntregados)     elEntregados.textContent     = fmt(undsEntregados);
        if (elConsumidos)     elConsumidos.textContent     = fmt(paqConsumidos);
        if (elConsumidosUnd)  elConsumidosUnd.textContent  = fmt(paqConsumidos * unidadEmpaque) + ' und';

        if (!elEstado) return;

        elEstado.classList.remove('balanceEstado--ok', 'balanceEstado--error', 'balanceEstado--warn');

        const origenUnds  = undsNetas + saldoInicioTurno + (paqConsumidos * unidadEmpaque) - saldoFinTurno;
        const destinoUnds = (paqAlmacenados * unidadEmpaque) + undsEntregados;
        const diferenciaUnds = origenUnds - destinoUnds;
        const balanceCoincide = Math.abs(diferenciaUnds) <= 0.001;

        const sinDatos = undsNetas === 0 && paqCreados === 0 && paqAlmacenados === 0 &&
            undsEntregados === 0 && paqConsumidos === 0 && saldoInicioTurno === 0 && saldoFinTurno === 0;

        if (sinDatos) {
            if (elIcono) elIcono.textContent = '—';
            if (elTexto) elTexto.textContent = 'Sin datos';
        } else if (balanceCoincide) {
            elEstado.classList.add('balanceEstado--ok');
            if (elIcono) elIcono.textContent = '✓';
            if (elTexto) elTexto.textContent = 'Conciliado';
        } else {
            elEstado.classList.add('balanceEstado--error');
            if (elIcono) elIcono.textContent = '✗';
            if (elTexto) elTexto.textContent = 'Diferencia: ' + (diferenciaUnds > 0 ? '+' : '') + fmt(diferenciaUnds) + ' und';
        }
    };

    window.actualizarBalanceSoplado = function (idReporte) {
        if (!idReporte) return;

        fetch('/api/soplado/balance?idReporte=' + idReporte, {
            method: 'GET',
            credentials: 'include'
        })
        .then(function (r) {
            if (!r.ok) throw new Error('HTTP ' + r.status);
            return r.json();
        })
        .then(function (json) {
            if (!json || !json.result) return;
            const b = json.result;
            const paqCreados     = parseFloat(b.paqCreados) || 0;
            const paqAlmacenados = parseFloat(b.paqAlmacenados) || 0;
            const undsEntregados = parseFloat(b.undsEntregados) || 0;
            const paqConsumidos  = parseFloat(b.paqConsumidos) || 0;
            const undsNetas      = parseFloat(b.undsNetas) || 0;
            const saldoInicioTurno = parseFloat(b.saldoInicioTurno) || 0;
            const saldoFinTurno    = parseFloat(b.saldoFinTurno) || 0;
            const unidadEmpaque = parseFloat(b.unidadEmpaque) || CAPACIDAD_PAQUETE_DEFAULT;
            window.unidadEmpaqueSoplado = unidadEmpaque;
            const canvaEntrega = document.getElementById('canvaEntregaSoplado');
            if (canvaEntrega) canvaEntrega.setAttribute('data-unidad-empaque', unidadEmpaque);
            renderBalance(paqCreados, paqAlmacenados, undsEntregados, paqConsumidos, undsNetas, saldoInicioTurno, saldoFinTurno, unidadEmpaque);
        })
        .catch(function (err) {
            console.error('Error al cargar balance soplado:', err);
            lanzarAlerta('Error al cargar balance de soplado. Intente nuevamente.', 'alerta-roja');
        });
    };

    // ── Tabla: entregas en línea ──────────────────────────────────────────────────
    window.actualizarTablaEntregaLinea = (idReporte) => {
        const tbody    = document.getElementById('tbodyEntregaLineaSoplado');
        const totalEl  = document.getElementById('totalEntregaLineaSoplado');
        const elBalance = document.getElementById('balanceUnidadesEntregados');
        if (!tbody) return;

        fetch(`/api/soplado/info-entrega-linea?idReporte=${idReporte}`, {
            method: 'GET',
            credentials: 'include'
        })
        .then(r => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json(); })
        .then(json => {
            const rows    = Array.isArray(json.result) ? json.result : [];
            const totalUnds = rows.reduce((s, r) => s + (parseInt(r.cantUnidades, 10) || 0), 0);

            if (elBalance) elBalance.dataset.unidades = totalUnds;
            if (totalEl)   totalEl.textContent        = `${fmt(totalUnds)} und`;

            tbody.innerHTML = rows.length === 0
                ? filaSinDatos(3, 'No hay entregas en línea registradas.')
                : rows.map(r => `
                    <tr data-modal="modalEditarEntregaLineaSoplado"
                        data-id="${r.idLineaEntregaLinea}"
                        data-id-reporte="${idReporte}"
                        class="trSelect trSelectEntregaLinea btnModal">
                        <td>${r.nombreLinea}</td>
                        <td>${fmt(r.cantUnidades)}</td>
                        <td>${r.nombreResponsableLinea}</td>
                    </tr>`).join('');
        })
        .catch(err => console.error('Error al cargar entregas en línea:', err));
    };

    // ── Tabla: paquetes almacenados ───────────────────────────────────────────────
    window.actualizarTablaAlmacenado = (idReporte) => {
        const tbody    = document.getElementById('tbodyAlmacenadoSoplado');
        const totalEl  = document.getElementById('totalAlmacenadoSoplado');
        const elBalance = document.getElementById('balancePaquetesAlmacenados');
        if (!tbody) return;

        fetch(`/api/soplado/info-entrega-almacenado?idReporte=${idReporte}`, {
            method: 'GET',
            credentials: 'include'
        })
        .then(r => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json(); })
        .then(json => {
            const rows    = Array.isArray(json.result) ? json.result : [];
            const totalPaq = rows.reduce((s, r) => s + (parseInt(r.cantPaquetes, 10) || 0), 0);

            if (elBalance) elBalance.dataset.paquetes = totalPaq;
            if (totalEl)   totalEl.textContent        = `${fmt(totalPaq)} paq`;

            tbody.innerHTML = rows.length === 0
                ? filaSinDatos(3, 'No hay paquetes almacenados registrados.')
                : rows.map(r => `
                    <tr data-modal="modalEditarAlmacenadoSoplado"
                        data-id="${r.idLineaEntregaPaquetesAlmacenados}"
                        data-id-reporte="${idReporte}"
                        class="trSelect trSelectAlmacenado btnModal">
                        <td>${r.nombreBodega}</td>
                        <td>${fmt(r.cantPaquetes)}</td>
                        <td>${fmt(r.cantUnidades)}</td>
                    </tr>`).join('');
        })
        .catch(err => console.error('Error al cargar paquetes almacenados:', err));
    };

    // ── Tabla: paquetes consumidos ────────────────────────────────────────────────
    window.actualizarTablaConsumido = (idReporte) => {
        const tbody   = document.getElementById('tbodyConsumidoSoplado');
        const totalEl = document.getElementById('totalConsumidoSoplado');
        if (!tbody) return;

        fetch(`/api/soplado/info-entrega-consumido?idReporte=${idReporte}`, {
            method: 'GET',
            credentials: 'include'
        })
        .then(r => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json(); })
        .then(json => {
            const rows    = Array.isArray(json.result) ? json.result : [];
            const totalPaq = rows.reduce((s, r) => s + (parseInt(r.cantPaquetes, 10) || 0), 0);

            if (totalEl) totalEl.textContent = `${fmt(totalPaq)} paq`;

            tbody.innerHTML = rows.length === 0
                ? filaSinDatos(2, 'No hay paquetes consumidos registrados.')
                : rows.map(r => `
                    <tr data-modal="modalEditarConsumidoSoplado"
                        data-id="${r.idLineaEntregaPaquetesConsumidos}"
                        data-id-reporte="${idReporte}"
                        class="trSelect trSelectConsumido btnModal">
                        <td>${r.lote}</td>
                        <td>${fmt(r.cantPaquetes)}</td>
                    </tr>`).join('');
        })
        .catch(err => console.error('Error al cargar paquetes consumidos:', err));
    };

    // ── Cálculo automático de total unidades al ingresar cantPaquetes ─────────────
    const mapaUnidades = {
        'cantPaquetesCreados': 'cantUnidadesCreados',
        'cantPaquetesAlmacenadoAgregar': 'cantUnidadesAlmacenadoAgregar',
        'cantPaquetesAlmacenadoEditar':  'cantUnidadesAlmacenadoEditar',
        'cantPaquetesConsumidoAgregar':  'cantUnidadesConsumidoAgregar',
        'cantPaquetesConsumidoEditar':   'cantUnidadesConsumidoEditar'
    };

    document.addEventListener('input', function (e) {
        const input = e.target.closest('.formatoNumero');
        if (!input || !mapaUnidades[input.id]) return;
        const paquetes = parseInt((input.value || '0').replace(/,/g, ''), 10) || 0;
        const unidadEmpaque = obtenerUnidadEmpaqueSoplado();
        const elUnd = document.getElementById(mapaUnidades[input.id]);
        if (elUnd) elUnd.value = new Intl.NumberFormat('en-US').format(paquetes * unidadEmpaque);
        if (elUnd) elUnd.textContent = new Intl.NumberFormat('en-US').format(paquetes * unidadEmpaque) + ' und';
    });

}
